import * as React from 'react';
import { Stack, Divider, Box } from '@mui/material';
import { AccountPreview, AccountPreviewProps } from './AccountPreview';

export interface AccountSidebarPreviewProps extends AccountPreviewProps {
  mini?: boolean;
}

export function AccountSidebarPreview(props: AccountSidebarPreviewProps) {
  const { handleClick, open, mini, ...otherProps } = props;

  return (
    <Stack direction="column" p={0} onClick={e => e.stopPropagation()}>
      <Divider />
      <Box py={open ? 0 : 1}>
        <AccountPreview handleClick={handleClick} open={!mini} {...otherProps} />
      </Box>
    </Stack>
  );
}
